// 创建事件总线对象
const eventBus = {
   
    events: {},
    /**
     * 订阅事件
     * @param {*} eventName 
     * @param {*} callback 
     */
    on(eventName, callback) 
    {
        if (!this.events[eventName]) 
        {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    },

    /**
     * 触发事件
     * @param {*} eventName 
     * @param {*} data 
     */
    emit(eventName, data) 
    {
        if (this.events[eventName]) 
        {
            this.events[eventName].forEach(callback => callback(data));
        }
    },
    
    /**
     * 取消事件
     * @param {*} eventName 
     * @param {*} callback 
     */
    off(eventName, callback) 
    {
        if (this.events[eventName]) 
        {
            const index = this.events[eventName].indexOf(callback);
            
            if (index!== -1) 
            {
                this.events[eventName].splice(index, 1);
            }
        }
    }
};
export default eventBus;